(ns ui.captions.page
  "The caption styles page under /ui/captions: every style looping a
   sample transcript, to review new styles. Nothing links the route."
  (:require [app.captions.words :as words]
            [ui.app-frame :as app-frame]
            [ui.captions.sample :as sample]
            [ui.captions.styles :as styles]
            [ui.hyperframes-templates.player :as player]))

(def sample-variables
  {"words" (words/composition-json sample/words)})

(defn style-card
  [{:keys [id name description]}]
  [:div
   {:replicant/key id
    :class ["flex" "gap-6" "rounded-lg" "border" "border-gray-200" "bg-white" "p-4"]}
   [:div
    {:class ["w-[240px]" "shrink-0" "rounded-md" "overflow-hidden" "bg-gray-800"]
     :style {:aspect-ratio "9 / 16"}}
    (player/element {:template-id (str "captions/" id)
                     :variables sample-variables
                     :width 1080
                     :height 1920
                     :loop? true
                     :style {:display "block"
                             :width "100%"
                             :height "100%"}})]
   [:div
    {:class ["flex" "flex-col" "gap-2" "min-w-0"]}
    [:h2 {:class ["text-lg" "font-semibold" "text-gray-900"]} name]
    [:p {:class ["text-sm" "text-gray-600"]} description]
    [:p {:class ["text-xs" "text-gray-500"]} (str "captions/" id)]]])

(defn panel
  [_state]
  [:div
   {:class ["p-6" "flex" "flex-col" "gap-4" "max-w-4xl"]}
   [:h1 {:class ["text-2xl" "font-bold" "text-gray-900"]}
    "Caption styles"]
   (into [:div {:class ["flex" "flex-col" "gap-4"]}]
         (map style-card styles/styles))])

(defn render
  [state]
  (app-frame/app-frame
    state
    (panel state)))

(def page
  {:page-id :pages/captions
   :route [["ui" "captions"]]
   :render #'render})
